"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Markdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_markdown_1 = __importDefault(require("react-markdown"));
var react_syntax_highlighter_1 = __importDefault(require("react-syntax-highlighter"));
var Markdown = function (_a) {
    var children = _a.children, syntaxHighlighterTheme = _a.syntaxHighlighterTheme, props = __rest(_a, ["children", "syntaxHighlighterTheme"]);
    return ((0, jsx_runtime_1.jsx)(react_markdown_1["default"], __assign({ components: {
            code: function (_a) {
                var node = _a.node, inline = _a.inline, className = _a.className, children = _a.children, props = __rest(_a, ["node", "inline", "className", "children"]);
                var match = /language-(\w+)/.exec(className || '');
                return !inline && match ? ((0, jsx_runtime_1.jsx)(react_syntax_highlighter_1["default"], __assign({ children: String(children).replace(/\n$/, ''), style: syntaxHighlighterTheme, language: match[1], customStyle: {
                        padding: '1rem',
                        fontSize: '85%'
                    }, PreTag: "div" }, props))) : ((0, jsx_runtime_1.jsx)("code", __assign({ className: className }, props, { children: children })));
            }
        } }, props, { children: children })));
};
exports.Markdown = Markdown;
